import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker/es';
import { et } from 'date-fns/esm/locale';
import { createDateFromBackendDate } from '../util/dateUtil';
import { patchPlayer } from '../util/api/requests';

export const PlayerPopup = ({ isVisible, setIsVisible, player, onSaved }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState(undefined);
  const [gender, setGender] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (player) {
      setFirstName(player.firstName || '');
      setLastName(player.lastName || '');
      // backend LocalDate arrives as [year, month, day]; empty when absent
      setDateOfBirth(
        Array.isArray(player.dateOfBirth)
          ? createDateFromBackendDate(player.dateOfBirth)
          : undefined
      );
      setGender(player.gender || '');
    }
  }, [player]);

  const save = async () => {
    setErrorMessage('');
    const payload = {
      id: player.id,
      firstName,
      lastName,
      // LocalDate wire format in this app is [year, month(1-based), day], or null
      dateOfBirth: dateOfBirth
        ? [
            dateOfBirth.getFullYear(),
            dateOfBirth.getMonth() + 1,
            dateOfBirth.getDate(),
          ]
        : null,
      gender: gender || null,
      // not editable here — echo back unchanged so they are never cleared
      clubId: player.clubId != null ? player.clubId : null,
      isCaptain: player.isCaptain != null ? player.isCaptain : null,
    };
    try {
      await patchPlayer(player.id, payload);
    } catch (error) {
      // Keep the popup open so the admin can see why (e.g. duplicate name) and fix it, instead of
      // the popup silently sitting there as it did before this guard existed.
      setErrorMessage(
        (error.response && error.response.data && error.response.data.message) ||
          'Mängija salvestamine ebaõnnestus'
      );
      return;
    }
    setIsVisible(false);
    onSaved();
  };

  return (
    <Popup open={isVisible} onClose={() => setIsVisible(false)} modal>
      {(close) => (
        <div>
          <button className="close-modal" onClick={close}>
            &times;
          </button>
          <h3 className="m-3 text-center">Muuda mängijat</h3>
          <Form className="popup-form">
            <Row>
              <Col md={6} lg={4} className="offset-md-3 offset-lg-4">
                <Row>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label>Eesnimi</Form.Label>
                      <Form.Control
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label>Perekonnanimi</Form.Label>
                      <Form.Control
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label>Sünniaeg</Form.Label>
                      <DatePicker
                        className="form-control"
                        wrapperClassName="w-100"
                        selected={dateOfBirth}
                        onChange={(d) => setDateOfBirth(d)}
                        dateFormat="dd.MM.yyyy"
                        locale={et}
                        showYearDropdown
                        dropdownMode="select"
                        isClearable
                        placeholderText="pp.kk.aaaa"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label>Sugu</Form.Label>
                      <Form.Control
                        as="select"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                      >
                        <option value="">Määramata</option>
                        <option value="MALE">Mees</option>
                        <option value="FEMALE">Naine</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <div className="d-flex justify-content-end mt-3">
                  <Button onClick={save}>Salvesta</Button>
                </div>
                {errorMessage && (
                  <Alert variant="danger" className={'m-3'}>
                    {errorMessage}
                  </Alert>
                )}
              </Col>
            </Row>
          </Form>
        </div>
      )}
    </Popup>
  );
};
